////////////////////////////////////////////////////////////////////////////////
// viem/chains
////////////////////////////////////////////////////////////////////////////////
export * from 'viem/chains';
//# sourceMappingURL=chains.js.map